import { HStack, Icon, Image } from "@chakra-ui/react";
import { PiFireSimpleFill } from "react-icons/pi";

import { RoundedButton } from "@/components/rounded-button";

const BASE_ASSET_PATH = "/assets/home/";
export const ID_TRENDING_RWAS = "trending-rwas";
export const ID_YIELD_VAULTS = "yield-vaults";
export const ID_LEVERED_STRATEGIES = "levered-strategies";
export const ID_EARN_INCENTIVES = "earn-incentives";
export const ID_PLUME_ASSETS = "plume-assets";
const NAV_ITEMS = [
  {
    name: "Trending RWAs",
    icon: (
      <Icon color="fg.muted">
        <PiFireSimpleFill />
      </Icon>
    ),
    href: `#${ID_TRENDING_RWAS}`,
  },
  {
    name: "Yield Vaults",
    icon: <Image src={BASE_ASSET_PATH + "nest-icon-gray.svg"} boxSize={6} />,
    href: `#${ID_YIELD_VAULTS}`,
  },
  // COMMENT OUT OPTIMIZER STRATEGIES FOR NOW
  // {
  //   name: 'Levered Strategies',
  //   icon: <Image src={BASE_ASSET_PATH + 'optimizer-arc-gray.svg'} boxSize={6} />,
  //   href: `#${ID_LEVERED_STRATEGIES}`,
  // },
  {
    name: "Earn Incentives",
    icon: <Image src={BASE_ASSET_PATH + "royco-r.svg"} boxSize={6} />,
    href: `#${ID_EARN_INCENTIVES}`,
  },
  {
    name: "Plume Assets",
    icon: (
      <Image src={BASE_ASSET_PATH + "plume-feather-gray.svg"} boxSize={6} />
    ),
    href: `#${ID_PLUME_ASSETS}`,
  },
];

export const HomeJumpLinks = () => {
  return (
    <>
      <HStack
        justifyContent="start"
        w="full"
        flexWrap={["wrap", "wrap", "nowrap"]}
      >
        {NAV_ITEMS.map((nav) => (
          <a href={nav.href} key={nav.href}>
            <RoundedButton
              color="fg.muted"
              variant="outline"
              bgColor="bg"
              _hover={{ bgColor: "bg.subtle" }}
              h={12}
              fontWeight="500"
            >
              {nav.icon}
              {nav.name}
            </RoundedButton>
          </a>
        ))}
      </HStack>
    </>
  );
};
